export default "__VITE_ASSET__e431aea7__"